import React from 'react';
import './Cartephoto2024.css';
import mariage20 from '../../Images/mariage gal/mariage20.jpg';
import mariage22 from '../../Images/mariage gal/mariage22.jpg';
import mariage23 from '../../Images/mariage gal/mariage23.jpg';
import mariage24 from '../../Images/mariage gal/mariage24.jpg';
import mariage25 from '../../Images/mariage gal/mariage25.jpg';
import mariage26 from '../../Images/mariage gal/mariage26.jpg';
import mariage27 from '../../Images/mariage gal/mariage27.jpg';
import mariage28 from '../../Images/mariage gal/mariage28.jpg';
import mariage29 from '../../Images/mariage gal/mariage29.jpg';
import mariage30 from '../../Images/mariage gal/mariage30.jpg';
import mariage31 from '../../Images/mariage gal/mariage31.jpg';
import mariage32 from '../../Images/mariage gal/mariage32.jpg';
import mariage36 from '../../Images/mariage gal/mariage36.jpg';
import mariage34 from '../../Images/mariage gal/mariage34.jpg';
import mariage35 from '../../Images/mariage gal/mariage35.jpg';


const Cartephoto2024 = () => {
    return (
        <div className="Cartephotos-container2">
           
            

            <div className="cards1-container2024">
                <div className="card24p">

                    <img src={mariage20} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage22} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage23} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage24} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage25} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage26} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage27} alt="" />
                </div>
                 
                <div className="card24p">
                    <img src={mariage28} alt="" />
                </div>

                <div className="card24p">
                    <img src={mariage29} alt="" />
                </div>
                
                <div className="card24p">
                    <img src={mariage30} alt="" />
                </div>
                 
                <div className="card24p">
                    <img src={mariage31} alt="" />
                </div>
                  
                <div className="card24p">
                    <img src={mariage32} alt="" />
                </div>
                   
                <div className="card24p">
                    <img src={mariage36} alt="" />
                </div>
                     
                <div className="card24p">
                    <img src={mariage34} alt="" />
                </div>  

                <div className="card24p">
                    <img src={mariage35} alt="" />
                </div>


            </div>
        </div>
        

    );
};

export default Cartephoto2024;